<!-- HomeLastLook.vue -->
<template>
<div class="debugOutline2">

    <v-card class="mt-1 pl-1 pr-1">

      <!--
      <div id = "intro" style = "text-align:center;">
        <h1>{{ timestampRT }}</h1>

        {{audioDisabled}}
         
      </div>
      -->

    <v-layout
        v-if="$store.state.sniffing!=undefined"
        wrap
        class="pt-0 ml-0 mr-0 pr-0"
        >

      <v-flex xs4 sm3 md2>
        TARGET: 
      </v-flex>
      <v-flex xs7 sm8 md4 lg10 class="font-weight-bold">
        {{ shortenDate(this.$store.getters.selectedDate) }}
        <!-- :        {{shortenDate(this.$store.getters.selectedDate)}} -->
      </v-flex>

      <v-flex xs4 sm3 md2 lg2>
        TIME(s):
      </v-flex>

      <v-flex xs7 sm8 md4 lg3 class="font-weight-bold">
        {{ $store.state.sniffing.timeFilter }} 
        <span v-if="$store.state.sniffing.timeFilter2.length>0" class="font-weight-regular"> - </span>
          {{ $store.state.sniffing.timeFilter2 }}
      </v-flex>
      <v-flex xs4 sm3 md2 lg1>
        COURSE(s):
      </v-flex>
      <v-flex xs7 sm7 md4 lg6 class="font-weight-bold">
        <span v-if="$vuetify.breakpoint.mdAndDown"> {{ courseFilterAbbreviated }}</span>  
        <span v-if="$vuetify.breakpoint.lgAndUp"> {{ $store.state.sniffing.courseFilter }}</span> 
      </v-flex>
      <v-flex xs4 sm3 md2 lg2>
        LAST LOOK: <!--{{$store.state.sniffing.sniffed}}-->
      </v-flex>
      <v-flex xs4 sm4 md2 lg2 class="font-weight-bold">
                                                         
        {{ getCorrectString($store.state.teeSheets[selectedNode].stats.tstamp,false) }}
        <v-icon 
          v-if="$vuetify.breakpoint.smAndUp"
          x-small 
          v-bind:class="classHourglass()"  
          >mdi-timer-sand-empty mdi-spin
        </v-icon>
                                                                <!--
                                                                <v-icon x-small>mdi-android mdi-spin</v-icon>
                                                                <br>
                                                                <v-icon x-small>mdi-eye-circle-outline mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-settings-outline mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-web mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-help-circle-outline mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-ship-wheel mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-flattr mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-clock-outline mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-orbit mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-autorenew mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-timer-sand-empty mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-information-outline mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-refresh mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-bug-outline mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-yin-yang mdi-spin</v-icon>
                                                                <v-icon x-small>mdi-longitude mdi-spin</v-icon>
                                                                -->
      </v-flex>

      <v-flex xs3 sm2 md1 lg1 
          offset-xs0 offset-sm0 offset-md0 
          class=" font-weight-bold"
          v-bind:class="classHourglass()"  
          >
          {{ timestampRT }}
      </v-flex>
      <v-flex xs1 sm2 md1 lg1 
        class="tSmaller" 
        v-if="$vuetify.breakpoint.mdAndDown">
          +{{ $store.state.sniffing.refreshSeconds }}<span v-if="$vuetify.breakpoint.smAndUp"> secs</span>
      </v-flex>


      <v-flex xs5 sm5 md2 lg1 v-if="$vuetify.breakpoint.lgAndUp">
        FREQUENCY:
      </v-flex>
      <v-flex xs6 sm3 md1 lg3 class="tSmaller" v-if="$vuetify.breakpoint.lgAndUp">
        +{{ $store.state.sniffing.refreshSeconds }} secs
      </v-flex>

      <v-flex xs12 sm2 md2 lg3           
        v-if="$vuetify.breakpoint.lgAndUp"
        >
            <span class="tSmaller tLightGray">
            {{ $store.state.sniffing.timestamp }}
            </span>
      </v-flex>


      <!-- remove this for now since the openings calc is not correct 
      <v-flex xs4 sm3 md2 lg2>
        Openings:
      </v-flex>
      <v-flex xs7 sm7 md4 lg10>
        <span class="font-weight-bold">{{ openings.length }}</span> <span class="tSmaller tLightGray">
          [{{ tableRows.length }} tee times for the day]</span>
      </v-flex>
      -->

      <v-flex xs4 sm3 md2 lg1 v-if="$vuetify.breakpoint.md">
        FREQUENCY:
      </v-flex>
      <v-flex xs4 sm3 md1 lg3 class="tSmaller" v-if="$vuetify.breakpoint.md">
        +{{ $store.state.sniffing.refreshSeconds }} secs
      </v-flex>

                                                    <!--
                                                    <v-card>
                                                    $store.state
                                                    {{$store.state}}
                                                    </v-card>
                                                    -->
                                                    <!--                                            
                                                    <div v-if="showAllOpenings">
                                                    <v-flex 
                                                      v-for="(item, index) in $store.state.openings" 
                                                      :key=item.hole+index
                                                      class='holeCard tSmaller tC '

                                                      v-bind:class="classObject(item.course)"

                                                      @mouseover="mouseOver(index)"
                                                      >
                                                        {{ shortTime(item.time) }}<br>
                                                        {{ abbrev(item.course) }}
                                                        {{ item.hole }}  <span class="players tSmaller">  {{ blankIfZero(item.players) }}  </span>  
                                                    </v-flex>
                                                    </div>
                                                    -->
        <!--
        <div class="tSmaller tGreen" v-if="$store.state.openings.length>0 && 1==0">
        <br>
        {{ $store.state.openings }}
        </div>

        <div class="tSmaller tBlue" v-if="1==0">
        <br>
        {{ $store.state.tableRows }}
        </div>

        <div class="tSmaller" v-if="1==0">
        <br>
        {{ reverseArray($store.state.messages) }}
        </div>
        -->

    </v-layout>

    <v-layout v-else>
      SNIFFING HAS NOT YET BEGUN...         {{ sniffMethod() }}
            <br>
              {{ $store.state.sniffing }}
              {{ $store.state }}
    </v-layout>

    </v-card>

</div>
</template>

<script>

// includes chelseaDateToYYYY_MM_DD()
import { exampleMixin } from '../mixins/exampleMixin.js'   // eslint-disable-line no-unused-vars

export default {

    mixins: [exampleMixin],

    //el: '#intro',

    data() {
        return {
            XsniffMethod: "sniff method is where?",
            timestampRT: "",
            nowTimeOnly: true,
            timeNow: -1,
            timeLastLook: -1,
            //audioDisabled: true,  // true if audio is disabled
        }
    },

    props: {
        audioDisabled: Boolean,
    },

    computed: {

      sniffMethod () {
        let x = this.getCorrectString(this.$store.state.sniffing.sniffed)
        return x
      },
      openings () {
        const d = "d"+this.$store.getters.selectedDate2
        return this.$store.state.teeSheets[d].openings
      },
      tableRows () {
        const d = "d"+this.$store.getters.selectedDate2
        return this.$store.state.teeSheets[d].tableRows
      },
      sniffedDateTime () {
        //let d = "d"+this.$store.getters.selectedDate2
        return this.$store.state.teeSheets[this.selectedNode].stats.tstamp
      },
      selectedNode () {
        return "d"+this.$store.getters.selectedDate2
      },
      refreshSecs () {
        //let d = "d"+this.$store.getters.selectedDate2
        return this.$store.state.sniffing.refreshSeconds
      },
      courseFilterAbbreviated () {
        const arr = this.$store.state.sniffing.courseFilter.split(" ")
        let s = "";
        for (let i=0;i<arr.length;i++) {
          s += arr[i].substring(0,3);
          if (i<arr.length-1) s += " "
        }
        return s
      }
    },

    watch: {

      sniffFromStore: function () {
        if (this.$store.state.sniffing!=undefined) {
          const d = this.$store.state.sniffing.sniffed
          this.sniffDT = new Date(d)
        }
        else this.sniffDT =  ""
      },
    },

    methods: {

      shortenDate (d) {
          // February 11, 2020 - Tuesday   ==> Feb 11 - Tue
          const i = d.indexOf(" ")
          const j = d.indexOf("-")

          let s = ""
          s += d.substring(0,3)+d.substring(i,i+3)
          s += d.substring(j-1,j+5)
          return s
      },

      getCorrectString (dateTimeString,includeYear) {
          var a  = new Date(dateTimeString);
          let s = ('00'+(a.getMonth()+1)).substring(('00'+(a.getMonth()+1)).length-2) +'/'
              +('00'+a.getDate()).substring(('00'+a.getDate()).length-2)+' ';
          if (includeYear) s += '/'+a.getFullYear()+' ';
          s += ('00'+a.getHours()).substring(('00'+a.getHours()).length-2)+':'
              +('00'+a.getMinutes()).substring(('00'+a.getMinutes()).length-2)+':'
              +('00'+a.getSeconds()).substring(('00'+a.getSeconds()).length-2);
          return s;
      },

      getNow: function() {
          const today = new Date();
          let mStr = String(today.getMonth()+1);
          if (mStr.length<2) mStr = "0"+mStr;
          let dStr = String(today.getDate()+1);
          if (dStr.length<2) dStr = "0"+dStr;
          let date = today.getFullYear()+'-'+ mStr +'-' + dStr;

          let hrsStr = String(today.getHours());
          if (hrsStr.length<2) hrsStr = "0"+hrsStr;
          let minStr = String(today.getMinutes());
          if (minStr.length<2) minStr = "0"+minStr;
          let secStr = String(today.getSeconds());
          if (secStr.length<2) secStr = "0"+secStr;
          const time = hrsStr + ":" + minStr + ":" + secStr;
          //const dateTime = date +' '+ time;
          if (this.nowTimeOnly) {
            this.timestampRT = time;
          }
          else {
            this.timestampRT = date +' '+ time;
          }

          //if (minStr=="00" && secStr=="00" ) this.playAudio();
          if (minStr.charAt(1)=="0" && secStr=="00") {
            this.playAudioTime(minStr);
            //alert("PLAY AUDIO");
          }

      },

      classHourglass: function () {
        const lastLook = this.$store.state.teeSheets[this.selectedNode].stats.timestamp
        const d = new Date();
        const secondsSinceLastLook = (d.getTime() - lastLook)/1000
            //console.log("secondsSinceLastLook",secondsSinceLastLook)

        const cycleSeconds = 6 * this.$store.state.sniffing.refreshSeconds

        let s = "";
        if (secondsSinceLastLook>cycleSeconds-10) {
          s = "red--text"
        }
        else if (secondsSinceLastLook>.75*cycleSeconds) {
          s = "orange--text"
        }
        else if (secondsSinceLastLook>.5*cycleSeconds) {
          s = "purple--text"
        }
        else if (secondsSinceLastLook>.25*cycleSeconds) {
          s = "blue--text"
        }
        return s
      },

      playAudioTime: function (hand) {
        if (this.audioDisabled) return

        // need to hard code these since the webpack require doesn't allow dynamic paths
        // format of the audio call is:     
        // const sound = ( new Audio( require('@/assets/foo.ogg') ).play();

      let audioT
      if (hand=="00") {
            audioT = new Audio(require('./hour.mp3'))
      }
      else if (hand=="10") {
            audioT = new Audio(require('./10.mp3'))
      }
      else if (hand=="20") {
            audioT = new Audio(require('./20.mp3'))
      }
      else if (hand=="30") {
            audioT = new Audio(require('./30.mp3'))
      }
      else if (hand=="40") {
            audioT = new Audio(require('./40.mp3'))
      }
      else if (hand=="50") {
            audioT = new Audio(require('./50.mp3'))
      }
        audioT.play()
      },

    },

    // https://stackoverflow.com/questions/57249466/getting-current-time-and-date-in-vue-js
    created() {
        setInterval(this.getNow, 1000);
    },

}

</script>

<style scoped>

</style>